import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "deals" }
const _hoisted_2 = { class: "active-disputes" }
const _hoisted_3 = { class: "active-disputes__title" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "all-disputes" }
const _hoisted_6 = { class: "all-disputes__title" }
const _hoisted_7 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DealsSection = _resolveComponent("DealsSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('labels.active_disputes')), 1)
      ]),
      _createVNode(_component_DealsSection, {
        "hide-header": true,
        ref: "activeDisputesSection"
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('labels.last_disputes')), 1)
      ]),
      _createVNode(_component_DealsSection, {
        "hide-header": true,
        ref: "lastDisputesSection"
      }, null, 512)
    ])
  ]))
}